module.exports = __webpack_public_path__ + "img/icon-youyou-right.9c327623.png";